<template>
  <div class="append-box">
    <v-mask
      style="background: rgba(0, 0, 0, 0.6)"
      @touchmove="gtouchmove"
      @click="handleClose"
    ></v-mask>
    <div
      v-bind:class="{
        'dialog-notice-box': true,
        'game-1018': gameId == '1018',
        'game-1048': gameId == '1048',
        'game-1049': gameId == '1049',
        'game-1050': gameId == '1050',
        'game-1051': gameId == '1051' && lang == 'cn',
        'game-1051-en': gameId == '1051' && lang != 'cn',
        'game-1054': gameId == '1054',
      }"
    >
      <div
        v-bind:class="{
          'animated baisonFadeInDown ani-dialog-notice-box': true,
          baisonFadeInUp: fadeOut,
        }"
      >
        <div class="help-title-1018" v-if="gameId == '1018'">
          <img
            src="@/assets/img/help/fish2d/popup_title_bangzhu.png"
            v-if="lang == 'cn'"
          />
          <img
            src="@/assets/img/help/fish2d/popup_title_bangzhu_en.png"
            v-else
          />
        </div>
        <div class="help-title-1048" v-if="gameId == '1048'">
          <img
            src="@/assets/img/help/fish2d/1048_help_title.png"
            v-if="lang == 'cn'"
          />
          <img src="@/assets/img/help/fish2d/1048_help_title_en.png" v-else />
        </div>
        <div class="help-title-1049" v-if="gameId == '1049'">
          <img
            src="@/assets/img/help/fish2d/1049_help_title.png"
            v-if="lang == 'cn'"
          />
          <img src="@/assets/img/help/fish2d/1049_help_title_en.png" v-else />
        </div>
        <div class="help-title-1050" v-if="gameId == '1050'">
          <img
            src="@/assets/img/help/fish2d/1050_help_title.png"
            v-if="lang == 'cn'"
          />
          <img src="@/assets/img/help/fish2d/1050_help_title_en.png" v-else />
        </div>
        <div class="help-title-1054" v-if="gameId == '1054'">
          <img
            src="@/assets/img/help/fish2d/1054_help_title.png"
            v-if="lang == 'cn'"
          />
          <img src="@/assets/img/help/fish2d/1054_help_title_en.png" v-else />
        </div>
        <div class="tag-menu-box" ref="tagMenuBox" v-if="this.multiLabel">
          <ul class="tag-menu-list">
            <li
              v-for="(item, i) in helpData"
              v-bind:class="{ 'tag-menu-item': true, selected: item.selected }"
              v-bind:key="i"
              @click="handleChangeTagMenu(item)"
              v-clickMusic
            >
              <div class="item-icon">
                <img :src="getIconSource(item.style, item.selected)" />
              </div>
              <div class="item-content">{{ item.title | filterTitle }}</div>
            </li>
          </ul>
        </div>
        <div
          v-bind:class="{
            'content-wrapper': true,
            'multi-label': multiLabel,
            'content-wrapper-1048': gameId == '1048',
            'content-wrapper-1049': gameId == '1049',
            'content-wrapper-1050': gameId == '1050',
            'content-wrapper-1051': gameId == '1051',
            'content-wrapper-1054': gameId == '1054',
          }"
          ref="contentWrapper"
        >
          <div class="content" v-if="item.type == 2">
            <img :src="imgHost + item.content" @load="loadImage" />
          </div>
          <div class="content" v-html="item.content" v-else></div>
        </div>
        <btnClose
          v-bind:class="{
            'close-pop-message-1018': gameId == '1018',
            'close-pop-message-1048': gameId == '1048',
            'close-pop-message-1049': gameId == '1049',
            'close-pop-message-1050': gameId == '1050',
            'close-pop-message-1051': gameId == '1051',
            'close-pop-message-1054': gameId == '1054',
          }"
          v-clickMusic
          @close="handleClose"
        ></btnClose>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import BScroll from "@better-scroll/core";
import btnClose from "@/components/btnClose.vue";
import store from "@/store/index";
import { deepClone } from "@/utils/index";
import { getHelpInfo } from "@/api/task";
export default {
  name: "dialogHelp2dFish",
  components: {
    "v-mask": vmask,
    btnClose,
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
  },
  data() {
    return {
      imgHost: "https://" + store.state.app.domain.replace("gw.", "task."),
      theme: store.state.app.theme,
      lang: "cn",
      fadeOut: false,
      tabMenuIndex: 1,
      gameId: 0,
      style: 1,
      multiLabel: false,
      helpData: [],
      scrollMenu: null,
      scrollContent: null,
      item: {
        type: 1,
        title: "",
        content: "",
      },
    };
  },
  watch: {
    closeAllPopUp(val) {
      if (val.key != "dialogHelp") {
        this.remove();
      }
    },
  },
  mounted() {
    store.dispatch("setCloseAllPopUp", "dialogHelp");
    this.scrollContent = new BScroll(this.$refs.contentWrapper, {
      click: true,
    });
    getHelpInfo(this.gameId, this.lang).then((res) => {
      res = res.data;
      if (res.code == 0) {
        if (res.result.data && res.result.data.length > 0) {
          this.helpData = this.getHelpData(res.result.data);
          this.item = this.filterItem(res.result.data[0]);
          this.multiLabel = res.result.data.length > 1 ? true : false;
          this.$nextTick(() => {
            this.initScroller(this.multiLabel);
          });
        }
      }
    });
  },
  filters: {
    filterTitle: function (value) {
      if (!value) return "";
      if (String(value).length > 4) {
        return String(value).substr(0, 4);
      } else {
        return value;
      }
    },
  },
  methods: {
    resetItem() {
      this.item = {
        type: 1,
        title: "",
        content: "",
      };
    },
    initScroller(isTags) {
      /**初始化滚动条 */
      if (isTags) {
        this.scrollMenu = new BScroll(this.$refs.tagMenuBox, {
          click: true,
        });
        this.scrollMenu && this.scrollMenu.refresh();
      }
      this.scrollContent && this.scrollContent.refresh();
    },
    getHelpData(list) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (i == 0) {
          list[i].selected = true;
        } else {
          list[i].selected = false;
        }
        arr.push(list[i]);
      }
      return arr;
    },
    getIconSource(style, selected = false) {
      let imgSource = "";
      switch (Number(style)) {
        case 1:
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelWF_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelWF_02.png");
          }
          break;
        case 2:
          if (selected) {
            imgSource = require("@/assets/img/help/UI_common_framelabelPX_01.png");
          } else {
            imgSource = require("@/assets/img/help/UI_common_framelabelPX_02.png");
          }
          break;
      }
      return imgSource;
    },
    loadImage() {
      this.scrollContent && this.scrollContent.refresh();
    },
    filterItem(item) {
      const newItem = deepClone(item);
      if (newItem.content) {
        newItem.content = String(newItem.content)
          .replaceAll(" ", "&ensp;")
          .replaceAll("\r", "<br />")
          .replaceAll("\n", "<br />");
      }
      return newItem;
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
      window.__dialogHelp = null;
    },
    handleClose() {
      this.fadeOut = true;
      setTimeout(() => {
        this.remove();
        this.fadeOut = false;
        window.__dialogNotice = null;
      }, 300);
    },
    handleChangeTagMenu(item) {
      this.resetItem();
      this.$nextTick(() => {
        let list = deepClone(this.helpData);
        let showContent = {};
        for (let i = 0; i < list.length; i++) {
          if (list[i].title == item.title) {
            list[i].selected = true;
            showContent = list[i];
          } else {
            list[i].selected = false;
          }
        }
        this.helpData = list;
        this.item = this.filterItem(showContent);
        this.$nextTick(() => {
          this.scrollContent && this.scrollContent.refresh();
          this.scrollContent.scrollTo(0, 0, 0);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 88889;
  .dialog-notice-box {
    font-family: Microsoft YaHei;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    .ani-dialog-notice-box {
      width: 100%;
      height: 100%;
      font-size: 0.12rem;
      -webkit-animation-duration: 0.3s;
      animation-duration: 0.3s;
      position: relative;
    }
    &.game-1018 {
      height: 2.68rem;
      width: 5.71rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/popup_big2_bg.png) no-repeat;
        background-size: cover;
      }
    }
    &.game-1048 {
      height: 2.825rem;
      width: 5.37rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/1048.png) no-repeat;
        background-size: cover;
      }
    }
    &.game-1049 {
      height: 3.3rem;
      width: 5.715rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/1049.png) no-repeat;
        background-size: cover;
      }
    }
    &.game-1050 {
      height: 2.78rem;
      width: 5.385rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/1050.png) no-repeat;
        background-size: cover;
      }
    }
    &.game-1051 {
      width: 5.115rem;
      height: 2.735rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/1051.png) no-repeat;
        background-size: cover;
      }
    }
    &.game-1051-en {
      width: 5.115rem;
      height: 2.735rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/1051_en.png) no-repeat;
        background-size: cover;
      }
    }
    &.game-1054 {
      width: 5.65rem;
      height: 2.96rem;
      .ani-dialog-notice-box {
        background: url(~@/assets/img/help/fish2d/1054.png) no-repeat;
        background-size: cover;
      }
    }
    .help-title-1018 {
      width: 0.445rem;
      height: 0.24rem;
      position: absolute;
      left: 50%;
      top: 0.03rem;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .help-title-1048 {
      width: 0.99rem;
      height: 0.265rem;
      position: absolute;
      left: 50%;
      top: 0.06rem;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .help-title-1049 {
      width: 0.455rem;
      height: 0.265rem;
      position: absolute;
      left: 50%;
      top: 0.22rem;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .help-title-1050 {
      width: 0.33rem;
      position: absolute;
      left: 50%;
      top: 0.13rem;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .help-title-1047 {
      width: 2.01rem;
      height: 0.515rem;
      position: absolute;
      left: 50%;
      top: 0.01rem;
      background: url(~@/assets/img/help/fish/title-bg.png) no-repeat;
      background-size: cover;
      transform: translateX(-50%);
      text-align: center;
      img {
        width: 0.575rem;
        height: 0.3rem;
      }
    }
    .help-title-1054 {
      width: 0.555rem;
      position: absolute;
      left: 0.9rem;
      top: 0.1rem;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-bg {
      width: 4.42rem;
      height: 2.02rem;
      position: absolute;
      left: 50%;
      bottom: 0.18rem;
      transform: translateX(-50%);
    }
    .tag-menu-box {
      position: absolute;
      left: 0.21rem;
      top: 0.51rem;
      width: 0.95rem;
      height: 1.965rem;
      background: url(~@/assets/img/help/UI_common_framelabelB_02.png) no-repeat;
      overflow: hidden;
      .tag-menu-list {
        .tag-menu-item {
          width: 100%;
          height: 0.42rem;
          line-height: 0.42rem;
          display: table;
          color: #709fcb;
          background: url(~@/assets/img/help/UI_common_framelabel_02.png)
            no-repeat;
          background-size: cover;
          .item-icon {
            display: table-cell;
            width: 0.38rem;
            text-align: center;
            img {
              height: 0.16rem;
              vertical-align: middle;
            }
          }
          .item-content {
            display: table-cell;
            height: 0.42rem;
            line-height: 0.42rem;
            font-size: 0.12rem;
          }
          &.selected {
            background: url(~@/assets/img/help/UI_common_framelabel_01.png)
              no-repeat;
            background-size: cover;
            .item-content {
              background-size: 0.16rem 0.16rem;
              color: #ffffff;
            }
          }
        }
      }
    }
    .content-wrapper {
      width: 5.15rem;
      height: 2rem;
      position: absolute;
      overflow: hidden;
      display: block;
      left: 0.28rem;
      top: 0.42rem;
      &.content-wrapper-1048 {
        left: 0.15rem;
        top: 0.4rem;
        width: 5.05rem;
        height: 2.2rem;
      }
      &.content-wrapper-1049 {
        left: 0.32rem;
        top: 0.45rem;
        width: 5.05rem;
        height: 2.4rem;
      }
      &.content-wrapper-1050 {
        left: 0.43rem;
        top: 0.38rem;
        width: 4.5rem;
        height: 2.2rem;
      }
      &.content-wrapper-1051 {
        left: 0.23rem;
        top: 0.42rem;
        width: 4.65rem;
        height: 2.1rem;
      }
      &.content-wrapper-1054 {
        left: 0.32rem;
        top: 0.65rem;
        width: 5rem;
        height: 1.95rem;
      }
      &.multi-label {
        left: 1.2rem;
        width: 3.35rem;
      }
      .content {
        font-size: 0.1rem;
        color: #ffffff;
        width: 100%;
        word-wrap: break-word;
        word-break: break-all;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .close-pop-message-1018 {
      position: absolute;
      right: -0.15rem;
      top: -0.12rem;
      width: 0.365rem;
      height: 0.39rem;
      background: url(~@/assets/img/help/fish/X2.png) no-repeat;
      background-size: cover;
    }
    .close-pop-message-1048 {
      position: absolute;
      right: -0.03rem;
      top: -0.03rem;
      width: 0.27rem;
      height: 0.28rem;
      background: url(~@/assets/img/help/fish2d/1048_close.png) no-repeat;
      background-size: cover;
    }
    .close-pop-message-1049 {
      position: absolute;
      right: -0.3rem;
      top: 0.1rem;
      width: 0.345rem;
      height: 0.38rem;
      background: url(~@/assets/img/help/fish2d/1049_close.png) no-repeat;
      background-size: cover;
    }
    .close-pop-message-1050 {
      position: absolute;
      right: 0rem;
      top: -0.05rem;
      width: 0.295rem;
      height: 0.3rem;
      background: url(~@/assets/img/help/fish2d/1050_close.png) no-repeat;
      background-size: cover;
    }
    .close-pop-message-1051 {
      position: absolute;
      right: 0rem;
      top: -0.025rem;
      width: 0.34rem;
      height: 0.34rem;
      background: url(~@/assets/img/help/fish2d/1051_close.png) no-repeat;
      background-size: cover;
    }
    .close-pop-message-1054 {
      position: absolute;
      right: 0rem;
      top: -0.025rem;
      width: 0.5rem;
      height: 0.515rem;
      background: url(~@/assets/img/help/fish2d/1054_close.png) no-repeat;
      background-size: cover;
    }
  }
}

@media all and (orientation: portrait) {
  .dialog-notice-box {
    transform: translate(-50%, -50%) rotate(90deg) !important;
    -webkit-transform: translate(-50%, -50%) rotate(90deg) !important;
    -moz-transform: translate(-50%, -50%) rotate(90deg) !important;
    -ms-transform: translate(-50%, -50%) rotate(90deg) !important;
    -o-transform: translate(-50%, -50%) rotate(90deg) !important;
  }
}
</style>